export const DEFAULT_TABLE_PAGE_LIMIT = 25;
export const TABLE_PAGE_LIMIT_OPTIONS = [5, 10, 25];